import { Box, Container } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { OperationalEquipmentHeader } from '@operations/features/operationalEquipment/components/molecules/OperationalEquipmentHeader'
import { OperationalEquipmentTable } from '@operations/features/operationalEquipment/components/organisms/OperationalEquipmentTable'
import { OperationalEquipmentUIStore } from '@operations/features/operationalEquipment/stores/operational-equipment.ui-store'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'

export const OperationalEquipmentPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()

    const { operationalEquipmentStore } = useOperationsStore()

    useAsyncFetch(async () => {
      await operationalEquipmentStore.fetchData()
    }, [operationalEquipmentStore])

    const operationalEquipmentUIStore = useMemo(
      () => new OperationalEquipmentUIStore(operationalEquipmentStore),
      [operationalEquipmentStore],
    )

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <OperationalEquipmentHeader />

        <Container sx={{ paddingY: theme.customSpacing.m }} data-cy='operational-equipment-table'>
          <OperationalEquipmentTable operationalEquipmentUIStore={operationalEquipmentUIStore} />
        </Container>
      </Box>
    )
  }),
)
